module.exports = __webpack_public_path__ + "img/logo-white@2x.ee820e6a.png";